import SideNavigationComponent from "./sideNavigation.component";

export default SideNavigationComponent;
